import HeroSection from './HeroSection'
import WelcomeKitSection from './WelcomeKitSection'
import HelpSection from './HelpSection'
import ProgramOfferingSection from './ProgramOfferingSection'
import RewardsSection from './RewardsSection'
import HowItWorksSection from './HowItWorksSection'
import FAQSection from './FAQSection'
import ContactSection from './ContactSection'
import DisclaimerSection from './DisclaimerSection'
import CopyrightSection from './CopyrightSection'

export {
  HeroSection,
  WelcomeKitSection,
  HelpSection,
  ProgramOfferingSection,
  RewardsSection,
  HowItWorksSection,
  FAQSection,
  ContactSection,
  DisclaimerSection,
  CopyrightSection,
}

const SemaPageSections = {
  HeroSection,
  WelcomeKitSection,
  HelpSection,
  ProgramOfferingSection,
  RewardsSection,
  HowItWorksSection,
  FAQSection,
  ContactSection,
  DisclaimerSection,
  CopyrightSection,
}

export default SemaPageSections
